// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reminder-categories-container {
  padding: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.page-header h1 {
  color: #ffffff;
  font-size: 28px;
  margin: 0;
}

.add-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s;
}

.add-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(102, 126, 234, 0.4);
}

.category-form-container {
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 25px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  margin-bottom: 30px;
}

.category-form h2 {
  color: #ffffff;
  margin-top: 0;
  margin-bottom: 20px;
}

.form-row {
  margin-bottom: 20px;
}

.input-group label {
  display: block;
  margin-bottom: 8px;
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
}

.input-group input[type="text"] {
  width: 100%;
  padding: 10px 12px;
  background: rgba(15, 23, 42, 0.6);
  color: var(--white, #ffffff);
  border: 2px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  font-size: 15px;
  transition: border-color 0.3s;
}

.input-group input[type="text"]:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
}

.icon-selector {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.icon-option {
  width: 50px;
  height: 50px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.05);
  cursor: pointer;
  font-size: 24px;
  transition: all 0.3s;
}

.icon-option:hover {
  border-color: #667eea;
  transform: scale(1.05);
  background: rgba(102, 126, 234, 0.15);
}

.icon-option.selected {
  border-color: #667eea;
  background: rgba(102, 126, 234, 0.2);
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.3);
}

.color-selector {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

.color-option {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 3px solid transparent;
  cursor: pointer;
  transition: all 0.3s;
}

.color-option:hover {
  transform: scale(1.1);
}

.color-option.selected {
  border-color: #ffffff;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.3), 0 0 0 4px #ffffff;
}

.color-picker {
  width: 50px;
  height: 40px;
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.05);
}

.form-actions {
  display: flex;
  gap: 10px;
  margin-top: 25px;
}

.save-btn, .cancel-btn {
  padding: 10px 20px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  font-size: 15px;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: all 0.3s;
}

.save-btn {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
}

.save-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(102, 126, 234, 0.4);
}

.cancel-btn {
  background: rgba(255, 255, 255, 0.1);
  color: #ffffff;
}

.cancel-btn:hover {
  background: rgba(255, 255, 255, 0.15);
}

.categories-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.category-card {
  background: rgba(255, 255, 255, 0.03);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  border-left: 4px solid;
  transition: all 0.3s;
}

.category-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.12);
}

.category-header {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 15px;
}

.category-icon {
  font-size: 32px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
}

.category-header h3 {
  margin: 0;
  color: #ffffff;
  font-size: 18px;
  flex: 1 1;
}

.category-meta {
  margin-bottom: 15px;
}

.reminder-count {
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  padding: 4px 10px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  display: inline-block;
}

.category-actions {
  display: flex;
  gap: 10px;
  justify-content: flex-end;
}

.edit-btn, .delete-btn {
  padding: 8px;
  border-radius: 8px;
  border: none;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.08);
  color: rgba(255, 255, 255, 0.7);
  transition: all 0.3s;
}

.edit-btn:hover {
  background: rgba(33, 150, 243, 0.2);
  color: #2196F3;
}

.delete-btn:hover {
  background: rgba(244, 67, 54, 0.2);
  color: #f44336;
}

.loading {
  text-align: center;
  padding: 50px;
  color: rgba(255, 255, 255, 0.8);
}

.no-data {
  text-align: center;
  padding: 50px;
  color: rgba(255, 255, 255, 0.8);
}

.no-data p {
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 20px;
}

.no-data button {
  margin-top: 20px;
  padding: 10px 20px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 15px;
  transition: all 0.3s;
}

.no-data button:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(102, 126, 234, 0.4);
}

/* Responsive */
@media (max-width: 768px) {
  .categories-grid {
    grid-template-columns: 1fr;
  }

  .page-header {
    flex-direction: column;
    gap: 15px;
    align-items: stretch;
  }
}

/* ============ LIGHT THEME OVERRIDES ============ */
[data-theme="light"] .page-header h1 {
  color: #1e293b;
}

[data-theme="light"] .category-form-container {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(15, 23, 42, 0.1);
}

[data-theme="light"] .category-form h2 {
  color: #1e293b;
}

[data-theme="light"] .input-group label {
  color: #1e293b;
}

[data-theme="light"] .input-group input[type="text"] {
  background: rgba(255, 255, 255, 0.9);
  color: #1e293b;
  border: 2px solid rgba(15, 23, 42, 0.15);
}

[data-theme="light"] .input-group input[type="text"]:focus {
  border-color: #64748b;
  box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.2);
}

[data-theme="light"] .icon-option {
  border: 2px solid rgba(15, 23, 42, 0.2);
  background: rgba(15, 23, 42, 0.03);
}

[data-theme="light"] .icon-option:hover {
  border-color: #64748b;
  background: rgba(100, 116, 139, 0.1);
}

[data-theme="light"] .icon-option.selected {
  border-color: #64748b;
  background: rgba(100, 116, 139, 0.15);
  box-shadow: 0 0 0 2px rgba(100, 116, 139, 0.3);
}

[data-theme="light"] .color-picker {
  border: 2px solid rgba(15, 23, 42, 0.2);
  background: rgba(15, 23, 42, 0.03);
}

[data-theme="light"] .cancel-btn {
  background: rgba(100, 116, 139, 0.08);
  color: #1e293b;
}

[data-theme="light"] .cancel-btn:hover {
  background: rgba(100, 116, 139, 0.12);
}

[data-theme="light"] .category-card {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(15, 23, 42, 0.1);
}

[data-theme="light"] .category-card:hover {
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(15, 23, 42, 0.15);
}

[data-theme="light"] .category-icon {
  background: rgba(15, 23, 42, 0.05);
}

[data-theme="light"] .category-header h3 {
  color: #1e293b;
}

[data-theme="light"] .reminder-count {
  color: #1e293b;
  background: rgba(15, 23, 42, 0.08);
}

[data-theme="light"] .edit-btn,
[data-theme="light"] .delete-btn {
  background: rgba(15, 23, 42, 0.05);
  color: rgba(30, 41, 59, 0.7);
}

[data-theme="light"] .edit-btn:hover {
  background: rgba(33, 150, 243, 0.15);
  color: #2196F3;
}

[data-theme="light"] .delete-btn:hover {
  background: rgba(244, 67, 54, 0.15);
  color: #f44336;
}

[data-theme="light"] .loading {
  color: #475569;
}

[data-theme="light"] .no-data {
  color: #475569;
}

[data-theme="light"] .no-data p {
  color: #64748b;
}
`, "",{"version":3,"sources":["webpack://./src/features/reminders/ReminderCategories.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,4BAA4B;EAC5B,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;EACpC,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iEAAiE;AACnE;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,yCAAyC;EACzC,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;EACzC,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,SAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,iBAAiB;EACjB,oCAAoC;EACpC,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA,eAAe;AACf;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;AACF;;AAEA,oDAAoD;AACpD;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,uCAAuC;EACvC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;;EAEE,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":[".reminder-categories-container {\n  padding: 30px;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n}\n\n.page-header h1 {\n  color: #ffffff;\n  font-size: 28px;\n  margin: 0;\n}\n\n.add-btn {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 16px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.3s;\n}\n\n.add-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 20px rgba(102, 126, 234, 0.4);\n}\n\n.category-form-container {\n  background: rgba(255, 255, 255, 0.03);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 25px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  margin-bottom: 30px;\n}\n\n.category-form h2 {\n  color: #ffffff;\n  margin-top: 0;\n  margin-bottom: 20px;\n}\n\n.form-row {\n  margin-bottom: 20px;\n}\n\n.input-group label {\n  display: block;\n  margin-bottom: 8px;\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.input-group input[type=\"text\"] {\n  width: 100%;\n  padding: 10px 12px;\n  background: rgba(15, 23, 42, 0.6);\n  color: var(--white, #ffffff);\n  border: 2px solid rgba(255, 255, 255, 0.15);\n  border-radius: 8px;\n  font-size: 15px;\n  transition: border-color 0.3s;\n}\n\n.input-group input[type=\"text\"]:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);\n}\n\n.icon-selector {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n\n.icon-option {\n  width: 50px;\n  height: 50px;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.05);\n  cursor: pointer;\n  font-size: 24px;\n  transition: all 0.3s;\n}\n\n.icon-option:hover {\n  border-color: #667eea;\n  transform: scale(1.05);\n  background: rgba(102, 126, 234, 0.15);\n}\n\n.icon-option.selected {\n  border-color: #667eea;\n  background: rgba(102, 126, 234, 0.2);\n  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.3);\n}\n\n.color-selector {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.color-option {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 3px solid transparent;\n  cursor: pointer;\n  transition: all 0.3s;\n}\n\n.color-option:hover {\n  transform: scale(1.1);\n}\n\n.color-option.selected {\n  border-color: #ffffff;\n  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.3), 0 0 0 4px #ffffff;\n}\n\n.color-picker {\n  width: 50px;\n  height: 40px;\n  border: 2px solid rgba(255, 255, 255, 0.2);\n  border-radius: 8px;\n  cursor: pointer;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.form-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 25px;\n}\n\n.save-btn, .cancel-btn {\n  padding: 10px 20px;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  font-size: 15px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  transition: all 0.3s;\n}\n\n.save-btn {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n}\n\n.save-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 20px rgba(102, 126, 234, 0.4);\n}\n\n.cancel-btn {\n  background: rgba(255, 255, 255, 0.1);\n  color: #ffffff;\n}\n\n.cancel-btn:hover {\n  background: rgba(255, 255, 255, 0.15);\n}\n\n.categories-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 20px;\n}\n\n.category-card {\n  background: rgba(255, 255, 255, 0.03);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);\n  border-left: 4px solid;\n  transition: all 0.3s;\n}\n\n.category-card:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n}\n\n.category-header {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  margin-bottom: 15px;\n}\n\n.category-icon {\n  font-size: 32px;\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n}\n\n.category-header h3 {\n  margin: 0;\n  color: #ffffff;\n  font-size: 18px;\n  flex: 1;\n}\n\n.category-meta {\n  margin-bottom: 15px;\n}\n\n.reminder-count {\n  color: rgba(255, 255, 255, 0.9);\n  font-size: 14px;\n  padding: 4px 10px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  display: inline-block;\n}\n\n.category-actions {\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n}\n\n.edit-btn, .delete-btn {\n  padding: 8px;\n  border-radius: 8px;\n  border: none;\n  cursor: pointer;\n  background: rgba(255, 255, 255, 0.08);\n  color: rgba(255, 255, 255, 0.7);\n  transition: all 0.3s;\n}\n\n.edit-btn:hover {\n  background: rgba(33, 150, 243, 0.2);\n  color: #2196F3;\n}\n\n.delete-btn:hover {\n  background: rgba(244, 67, 54, 0.2);\n  color: #f44336;\n}\n\n.loading {\n  text-align: center;\n  padding: 50px;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.no-data {\n  text-align: center;\n  padding: 50px;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.no-data p {\n  color: rgba(255, 255, 255, 0.7);\n  margin-bottom: 20px;\n}\n\n.no-data button {\n  margin-top: 20px;\n  padding: 10px 20px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 15px;\n  transition: all 0.3s;\n}\n\n.no-data button:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 10px 20px rgba(102, 126, 234, 0.4);\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .categories-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .page-header {\n    flex-direction: column;\n    gap: 15px;\n    align-items: stretch;\n  }\n}\n\n/* ============ LIGHT THEME OVERRIDES ============ */\n[data-theme=\"light\"] .page-header h1 {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .category-form-container {\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid rgba(15, 23, 42, 0.1);\n}\n\n[data-theme=\"light\"] .category-form h2 {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .input-group label {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .input-group input[type=\"text\"] {\n  background: rgba(255, 255, 255, 0.9);\n  color: #1e293b;\n  border: 2px solid rgba(15, 23, 42, 0.15);\n}\n\n[data-theme=\"light\"] .input-group input[type=\"text\"]:focus {\n  border-color: #64748b;\n  box-shadow: 0 0 0 3px rgba(100, 116, 139, 0.2);\n}\n\n[data-theme=\"light\"] .icon-option {\n  border: 2px solid rgba(15, 23, 42, 0.2);\n  background: rgba(15, 23, 42, 0.03);\n}\n\n[data-theme=\"light\"] .icon-option:hover {\n  border-color: #64748b;\n  background: rgba(100, 116, 139, 0.1);\n}\n\n[data-theme=\"light\"] .icon-option.selected {\n  border-color: #64748b;\n  background: rgba(100, 116, 139, 0.15);\n  box-shadow: 0 0 0 2px rgba(100, 116, 139, 0.3);\n}\n\n[data-theme=\"light\"] .color-picker {\n  border: 2px solid rgba(15, 23, 42, 0.2);\n  background: rgba(15, 23, 42, 0.03);\n}\n\n[data-theme=\"light\"] .cancel-btn {\n  background: rgba(100, 116, 139, 0.08);\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .cancel-btn:hover {\n  background: rgba(100, 116, 139, 0.12);\n}\n\n[data-theme=\"light\"] .category-card {\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid rgba(15, 23, 42, 0.1);\n}\n\n[data-theme=\"light\"] .category-card:hover {\n  background: rgba(255, 255, 255, 1);\n  border: 1px solid rgba(15, 23, 42, 0.15);\n}\n\n[data-theme=\"light\"] .category-icon {\n  background: rgba(15, 23, 42, 0.05);\n}\n\n[data-theme=\"light\"] .category-header h3 {\n  color: #1e293b;\n}\n\n[data-theme=\"light\"] .reminder-count {\n  color: #1e293b;\n  background: rgba(15, 23, 42, 0.08);\n}\n\n[data-theme=\"light\"] .edit-btn,\n[data-theme=\"light\"] .delete-btn {\n  background: rgba(15, 23, 42, 0.05);\n  color: rgba(30, 41, 59, 0.7);\n}\n\n[data-theme=\"light\"] .edit-btn:hover {\n  background: rgba(33, 150, 243, 0.15);\n  color: #2196F3;\n}\n\n[data-theme=\"light\"] .delete-btn:hover {\n  background: rgba(244, 67, 54, 0.15);\n  color: #f44336;\n}\n\n[data-theme=\"light\"] .loading {\n  color: #475569;\n}\n\n[data-theme=\"light\"] .no-data {\n  color: #475569;\n}\n\n[data-theme=\"light\"] .no-data p {\n  color: #64748b;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
